import { useTranslation } from 'react-i18next';
import { programTimeline } from '@/mocks/seminarData';

const PROGRAM_COUNT = 4;

const imageUrls: Record<string, string> = {
  'seminar-period1': '/images/generated/seminar-period1-2026.jpg',
  'seminar-period2': '/images/generated/seminar-period2-2026.jpg',
  'seminar-period3': '/images/generated/seminar-period3-2026.jpg',
  'seminar-period4': '/images/generated/seminar-period4-2026.jpg',
};

export default function ProgramTimeline() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            TODAY'S PROGRAM
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('seminar.program.altTitle')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('seminar.program.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        {/* Timeline */}
        <div className="relative space-y-12 md:space-y-16">
          {Array.from({ length: PROGRAM_COUNT }, (_, index) => {
            const item = programTimeline[index];
            const isEven = index % 2 === 0;
            return (
              <div key={index} className={['flex flex-col gap-8 md:gap-10 items-start', isEven ? 'md:flex-row' : 'md:flex-row-reverse'].join(' ')}>
                {/* Image */}
                <div className="w-full md:w-[45%]">
                  <div className="overflow-hidden">
                    <img
                      src={imageUrls[item.imageSeq]}
                      alt={t(`seminar.program.${index}.title`) + ' - ' + t('seminar.program.altTitle')}
                      title={t('seminar.hero.imgTitle') + ' - ' + t(`seminar.program.${index}.title`)}
                      className="w-full object-cover object-top transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                  <div className="mt-3 h-[1px] bg-gradient-to-r from-transparent via-accent-500/20 to-transparent"></div>
                </div>

                {/* Content */}
                <div className="w-full md:w-[55%] pt-0 md:pt-2">
                  <span className="inline-block text-[14px] text-accent-600 tracking-[0.08em] font-medium mb-3 font-label whitespace-nowrap">
                    {t(`seminar.program.${index}.time`)}
                  </span>
                  <div className="flex items-center gap-3 mb-3">
                    <p className="text-[12px] text-accent-500/60 tracking-[0.15em] font-label">
                      {t(`seminar.program.${index}.titleEn`).toUpperCase()}
                    </p>
                  </div>
                  <h3 className="font-heading text-lg text-foreground-900 tracking-[0.06em] mb-3">
                    {t(`seminar.program.${index}.title`)}
                  </h3>
                  <p className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">
                    {t(`seminar.program.${index}.description`)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Note */}
        {String(t('seminar.program.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mt-12 text-center">{__s}</p>))}
      </div>
    </section>
  );
}
